document.addEventListener('DOMContentLoaded', function() {
    function getTranslation(key, language) {
        if (!window.customTranslations || !window.customTranslations[language]) {
            return null;
        }
        
        const keyParts = key.split('.');
        let translation = window.customTranslations[language];
        
        for (const part of keyParts) {
            if (translation && translation[part]) {
                translation = translation[part];
            } else {
                return null;
            }
        }
        
        return translation;
    }

    function initializeTranslations() {
        const elements = document.querySelectorAll('[data-custom-translate]');
        const currentLanguage = document.documentElement.lang || 'en';
        
        elements.forEach(element => {
            const translationKey = element.getAttribute('data-custom-translate');
            const translation = getTranslation(translationKey, currentLanguage);
            if (translation) {
                element.textContent = translation;
            }
        });
    }

    initializeTranslations();

    const upsellWidget = document.getElementById('custom-upsell-widget');
    if (!upsellWidget) return;

    const mainProductId = upsellWidget.dataset.mainProductId;
    const addButtons = document.querySelectorAll('.custom-upsell-add');
    const messageElement = document.getElementById('custom-upsell-message');
    const currentLanguage = document.documentElement.lang || 'en';

    const addedStates = new Map();
    const lineItemKeys = new Map();

    function showMessage(message, isError = false) {
        if (!isError || !messageElement) return;

        let translatedMessage = message;

        if (message.includes('Failed to add product')) {
            const translatedError = getTranslation('upsell-widget.Failed to add product', currentLanguage) || 'Failed to add product';
            const translatedTryAgain = getTranslation('upsell-widget.Please try again', currentLanguage) || 'Please try again';
            translatedMessage = `${translatedError}. ${translatedTryAgain}.`;
        } else if (message.includes('Failed to remove product')) {
            const translatedError = getTranslation('upsell-widget.Failed to remove product', currentLanguage) || 'Failed to remove product';
            const translatedTryAgain = getTranslation('upsell-widget.Please try again', currentLanguage) || 'Please try again';
            translatedMessage = `${translatedError}. ${translatedTryAgain}.`;
        }

        messageElement.textContent = translatedMessage;
        messageElement.className = 'error';
        messageElement.style.display = 'block';
        setTimeout(() => {
            messageElement.style.display = 'none';
        }, 3000);
    }

    async function getCurrentCart() {
        const cartUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root 
            ? window.Shopify.routes.root + 'cart.js' 
            : '/cart.js';
        
        const response = await fetch(cartUrl);
        return response.json();
    }

    function addToCart(variantId, quantity) {
        const cartUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root 
            ? window.Shopify.routes.root + 'cart/add.js' 
            : '/cart/add.js';

        return fetch(cartUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: [{
                    id: Number(variantId),
                    quantity: quantity
                }]
            })
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(err => {
                    throw new Error(err.description || err.message || 'Error adding product to cart');
                });
            }
            return response.json();
        })
        .then(data => {
            if (data.status && data.status !== 200 && data.status !== 'ok') {
                throw new Error(data.description || 'Error adding product to cart');
            }
            // Store the line item key
            if (data.key) {
                lineItemKeys.set(variantId, data.key);
            }
            return data;
        });
    }

    function removeFromCart(variantId) {
        const cartUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root 
            ? window.Shopify.routes.root + 'cart/change.js' 
            : '/cart/change.js';

        const lineKey = lineItemKeys.get(variantId);
        
        if (!lineKey) {
            return getCurrentCart().then(cart => {
                const item = cart.items.find(i => String(i.variant_id) === String(variantId));
                if (!item) {
                    throw new Error('Item not found in cart');
                }
                
                return fetch(cartUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: item.key,
                        quantity: 0
                    })
                })
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(err => {
                            throw new Error(err.description || err.message || 'Error removing product from cart');
                        });
                    }
                    return response.json();
                })
                .then(data => {
                    lineItemKeys.delete(variantId);
                    return data;
                });
            });
        }

        return fetch(cartUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: lineKey,
                quantity: 0
            })
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(err => {
                    throw new Error(err.description || err.message || 'Error removing product from cart');
                });
            }
            return response.json();
        })
        .then(data => {
            if (data.status && data.status !== 200 && data.status !== 'ok') {
                throw new Error(data.description || 'Error removing product from cart');
            }
            lineItemKeys.delete(variantId);
            return data;
        });
    }

    async function updateCart() {
        try {
            const cartState = await getCurrentCart();

            const cartCountElements = document.querySelectorAll('.cart-count');
            cartCountElements.forEach(el => {
                el.textContent = cartState.item_count;
            });

            const cartSubtotalElements = document.querySelectorAll('.cart-subtotal');
            if (window.Shopify && window.Shopify.formatMoney) {
                cartSubtotalElements.forEach(el => {
                    el.innerHTML = window.Shopify.formatMoney(cartState.total_price);
                });
            }

            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartState }));
        } catch (error) {
            console.error('Error updating cart:', error);
        }
    }

    function setAddedState(button, added = false) {
        const variantId = button.dataset.variantId;
        const stateKey = `${mainProductId}_${variantId}`;
        
        if (added) {
            addedStates.set(stateKey, true);
            button.classList.add('added');
            button.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="check-icon">
                    <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <span data-custom-translate="upsell-widget.Added">Added</span>
            `;
            const addedText = button.querySelector('[data-custom-translate="upsell-widget.Added"]');
            if (addedText) {
                const translation = getTranslation('upsell-widget.Added', currentLanguage);
                if (translation) addedText.textContent = translation;
            }
        } else {
            addedStates.delete(stateKey);
            button.classList.remove('added');
            button.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="cart-icon">
                    <circle cx="9" cy="21" r="1"></circle>
                    <circle cx="20" cy="21" r="1"></circle>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                </svg>
                <span data-custom-translate="upsell-widget.Add">Add</span>
            `;
            const addText = button.querySelector('[data-custom-translate="upsell-widget.Add"]');
            if (addText) {
                const translation = getTranslation('upsell-widget.Add', currentLanguage);
                if (translation) addText.textContent = translation;
            }
        }
    }

    addButtons.forEach(button => {
        button.addEventListener('click', function() {
            const variantId = this.dataset.variantId;
            if (!variantId) {
                console.error('No variant ID found on button');
                return;
            }

            const isAdded = this.classList.contains('added');
            this.disabled = true;

            if (isAdded) {
                removeFromCart(variantId)
                    .then(() => {
                        updateCart();
                        setAddedState(this, false);
                    })
                    .catch(error => {
                        console.error('Error removing from cart:', error);
                        showMessage('Failed to remove product. Please try again.', true);
                    })
                    .finally(() => {
                        this.disabled = false;
                    });
            } else {
                addToCart(variantId, 1)
                    .then(() => {
                        updateCart();
                        setAddedState(this, true);
                    })
                    .catch(error => {
                        console.error('Error adding to cart:', error);
                        showMessage('Failed to add product. Please try again.', true);
                    })
                    .finally(() => {
                        this.disabled = false;
                    });
            }
        });
    });
});